import { render, staticRenderFns } from "./BookingSlots.vue?vue&type=template&id=45f2a7a6"
import script from "./BookingSlots.vue?vue&type=script&lang=js"
export * from "./BookingSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports